import axios from 'axios';
 
class UploadService { 
 
  postAvatar(payload, type) {   
    return axios.put(`company/avatar/${type}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }); 
  } 
  postAvatarHacker(payload) {   
    return axios.put(`hacker/avatar`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }); 
  } 
}

export default new UploadService();